import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import LazyHydrate from 'react-lazy-hydration';
import map from 'lodash/map';
import get from 'lodash/get';
import forEach from 'lodash/forEach';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import beautifyNumber from 'helpers/beautifyNumber';
import Dict from 'api/data-dict';
import preload from 'api/data-preload';
import seoPreload, { seoDecorator } from 'api/seo';
import { InputLabel, Input, ComboboxInputWrapper } from 'containers/form';
import contentBlock, { blockPreloader } from 'containers/content-block';
import Button from 'components/button';
import Row, { Col } from 'components/row';
import { iconTypes } from 'components/icon';
import Container from 'components/container';
import Breadcrumbs from 'components/breadcrumbs';
import { OpenGraphImage } from 'components/image';

import linksDomik from 'src-sites/domik/links';
import blockConfig from 'src-sites/domik/blocks/config';
import BlockWrapper from 'src-sites/domik/blocks/block-wrapper';

import UKR from './assets/currencyFlag/ukr.png';
import RUS from './assets/currencyFlag/rus.png';
import EUR from './assets/currencyFlag/eur.png';
import USD from './assets/currencyFlag/usd.png';
import imgLogoPrivat from './assets/logoPrivat.png';

import translates from './converter-i18n';

import 'styles/domik/section-finance/_page-converter.scss';

const bemClasses = new Bem('pageConverter');
const bemClassesDD = new Bem('dropDownList');

const currencyConfig = {
  uah: {
    flag: UKR,
    name_standart: 'UAH'
  },
  eur: {
    flag: EUR,
    name_standart: 'EUR'
  },
  usd: {
    flag: USD,
    name_standart: 'USD'
  },
  rub: {
    flag: RUS,
    name_standart: 'RUB'
  }
}

@preload({
  currencies: [Dict.preload, { url: 'currencies-full' }],
  ...blockPreloader({
    project: 'domik',
    entity: 'converterPage'
  }, blockConfig, []),
  ...seoPreload({ entity: 'converterPage' }, [])
})
@seoDecorator({
  advancedVars: {}
})
@I18nHoc(translates())
export default class PageConverter extends Component {
  static propTypes = {
    className: PropTypes.string,
    seoData: PropTypes.shape({}),
    currencies: PropTypes.shape({})
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.state = {
      type: 'buy',
      youGive: '',
      youGiveCurrency: 'uah',
      youTakeCurrency: 'usd',
    }

    const { currencies = {} } = props;
    const currenciesData = currencies.data || [];
    forEach(currenciesData, (val) => {
      this[val.id] = {
        buy: val.exchange_buy,
        sale: val.exchange_sell,
      };
    });
  }

  showBuy =()=> this.setState({ type: 'buy'});

  showSale =()=> this.setState({ type: 'sale'});

  onYouGiveChange =(data)=> this.setState({ youGive: data});

  changeYouGiveCurrency =(key)=> {
    this.setState({ youGiveCurrency: key });
    this.cwYouGiveRef.closeDropDown();
  }

  changeYouTakeCurrency =(key)=> {
    this.setState({ youTakeCurrency: key });
    this.cwYouTakeRef.closeDropDown();
  }

  exchangeGiveAndTake =()=> {
    const { youGiveCurrency, youTakeCurrency } = this.state;
    this.setState({ youGiveCurrency: youTakeCurrency, youTakeCurrency: youGiveCurrency });
  }

  renderFlagAndName(it, key, func) {
    const itProps = {}

    if (key) itProps.key = key;
    if (func) itProps.onClick = func;

    return (
      <Fragment {...itProps}>
        <img {...bemClasses('icon', 'img')} src={it.flag} alt="" />
        <span {...bemClasses('text', 'dd')} children={it.name_standart} />
      </Fragment>
    );
  }

  render() {
    const { i18n } = this;
    const { type, youGive, youGiveCurrency, youTakeCurrency } = this.state;
    const { className, seoData } = this.props;
    const yuoTake = beautifyNumber(Math.round(youGive * this[youGiveCurrency][type] / this[youTakeCurrency][type] * 100) / 100);
    const header = get(seoData, 'header') ? seoData.header : i18n('currencyConverter');
    const dataBreadcrumbs = [
      {
        name: i18n('breadcrumbsMain'),
        builder: linksDomik.sectionDomik,
        builderProps: { title: i18n('breadcrumbsMain') }
      }, {
        name: header,
        builder: linksDomik.sectionConverter,
        builderProps: { title: header }
      }
    ];

    return (
      <div {...bemClasses({ extra: className })}>
        <LazyHydrate ssrOnly>
          <OpenGraphImage />
        </LazyHydrate>
        <div {...bemClasses('content')}>
          <Container body>
            <div {...bemClasses('title')}>
              <div {...bemClasses('text')}><h1 children={header} /></div>
            </div>
            <div {...bemClasses('main')}>
              <Row {...bemClasses('row', 'main')}>
                <Col {...bemClasses('col', 'input')} allPr={0}>
                  <InputLabel
                    {...bemClasses('label')}
                    schema={{ label: i18n('currencySale')}}
                  />
                  <Input
                    {...bemClasses('input')}
                    onChange={this.onYouGiveChange}
                    value={youGive || ''}
                    schema={{ class: 'RuleFloat', placeholder: '0' }}
                    noLabel
                    noError
                  />
                  <ComboboxInputWrapper
                    {...bemClasses('dd')}
                    ref={el => this.cwYouGiveRef = el}
                    modalContentNoPadding
                    noError
                    list
                  >
                    {this.renderFlagAndName(currencyConfig[youGiveCurrency])}
                    <div {...bemClassesDD('contentContainer')}>
                      <div {...bemClassesDD('content')}>
                        {map(currencyConfig, (it, key) => (
                          <Button
                            key={key}
                            {...bemClasses('btn', 'listDD')}
                            onClick={() => this.changeYouGiveCurrency(key)}
                            label={this.renderFlagAndName(it, key)}
                          />
                        ))}
                      </div>
                    </div>
                  </ComboboxInputWrapper>
                </Col>
                <Col {...bemClasses('col', 'btn')} allAuto allPr={0}>
                  <Button
                    {...bemClasses('btn', 'toConverter')}
                    onClick={this.exchangeGiveAndTake}
                    iconType={iconTypes.converter}
                  />
                </Col>
                <Col {...bemClasses('col', 'input')} allPr={0}>
                  <InputLabel
                    {...bemClasses('label')}
                    schema={{ label: i18n('currencyPurchase')}}
                  />
                  <Input
                    {...bemClasses('input')}
                    // onChange={this.onYouGiveChange}
                    value={yuoTake || ''}
                    schema={{ placeholder: '0', readOnly: true }}
                    noLabel
                    noError
                  />
                  <ComboboxInputWrapper
                    {...bemClasses('dd')}
                    ref={el => this.cwYouTakeRef = el}
                    modalContentNoPadding
                    noError
                    list
                  >
                    {this.renderFlagAndName(currencyConfig[youTakeCurrency])}
                    <div {...bemClassesDD('contentContainer')}>
                      <div {...bemClassesDD('content')}>
                        {map(currencyConfig, (it, key) => (
                          <Button
                            key={key}
                            {...bemClasses('btn', 'listDD')}
                            onClick={() => this.changeYouTakeCurrency(key)}
                            label={this.renderFlagAndName(it, key)}
                          />
                        ))}
                      </div>
                    </div>
                  </ComboboxInputWrapper>
                </Col>
              </Row>
              <Row {...bemClasses('row', 'info')}>
                <Col {...bemClasses('col', 'btns')} allFlex allAuto allPr={0}>
                  <Button
                    {...bemClasses('btn', { purchaseSale: true, active: type === 'buy' })}
                    onClick={this.showBuy}
                    label={i18n('purchase')}
                    title={i18n('purchase')}
                  />
                  <Button
                    {...bemClasses('btn', { purchaseSale: true, active: type === 'sale' })}
                    onClick={this.showSale}
                    label={i18n('sale')}
                    title={i18n('sale')}
                  />
                </Col>
                <Col {...bemClasses('col', 'info')} allFlex allPr={0}>
                  {this.usd[type] &&
                    <span {...bemClasses('text', 'price')} children={`1$ = ${this.usd[type]}\u00a0грн`} />
                  }
                  {this.eur[type] &&
                    <span {...bemClasses('text', 'price')} children={`1€ = ${this.eur[type]}\u00a0грн`} />
                  }
                  {this.rub[type] &&
                    <span {...bemClasses('text', 'price')} children={`1₽ = ${this.rub[type]}\u00a0грн`} />
                  }
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img', 'logoPrivat')} src={imgLogoPrivat} alt="Приват" loading="lazy" decoding="async" />
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Container body>
          <LazyHydrate whenVisible>
            {contentBlock(blockConfig, 'bottom1', this.props, { wrapper: BlockWrapper, withContainer: false })}
            {contentBlock(blockConfig, 'bottom2', this.props, { wrapper: BlockWrapper, withContainer: false })}
            {contentBlock(blockConfig, 'bottom3', this.props, { wrapper: BlockWrapper, withContainer: false })}
          </LazyHydrate>
          <Breadcrumbs {...bemClasses('breadcrumbs')} data={dataBreadcrumbs} />
        </Container>
      </div>
    );
  }
}
